import React from 'react'

export interface Props {
  country: string
  width?: number
  height?: number
  style?: React.CSSProperties
  className?: string
}

export const FlagIcon: React.FC<Props> = ({
  country,
  width = 18,
  height = 13,
  style = {},
  className = '',
}) => {
  return (
    <img
      className={className}
      src={`https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/${country}.svg`}
      alt={`${country} flag icon`}
      width={width}
      height={height}
      style={{ display: 'block', ...style }}
      loading={'lazy'}
    />
  )
}
